export const text_extension = {
  light: {
    text: {
      color: "{surface.700}",
      hoverColor: "{surface.800}",
      mutedColor: "{surface.500}",
      hoverMutedColor: "{surface.600}",
    },

    textcolinput: {
      color: "{textcolinput.400}",
    },
  },
  dark: {
    text: {
      color: "{surface.700}",
      hoverColor: "{surface.800}",
      mutedColor: "{surface.500}",
      hoverMutedColor: "{surface.600}",
    },

    textcolinput: {
      color: "{textcolinput.500}",
    },
  },
};
